import { render, staticRenderFns } from "./SkupSuorganizatorEdit.vue?vue&type=template&id=916473b8&scoped=true&"
import script from "./SkupSuorganizatorEdit.vue?vue&type=script&lang=js&"
export * from "./SkupSuorganizatorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916473b8",
  null
  
)

export default component.exports